const GetCountries = async ({setter}) => {
  try {
    const americasResponse = await fetch('https://restcountries.com/v3.1/region/americas?fields=name,translations,cca2')
    const americasData = await americasResponse.json()
    
    const spainResponse = await fetch('https://restcountries.com/v3.1/name/spain?fields=name,translations,cca2')
    const spainData = await spainResponse.json()
    
    const allCountries = [...americasData, ...spainData]
    
    const spanishNames = allCountries.map((country, index) => ({
      id: index,
      name: country.translations.spa.common,
      code: country.cca2
    }))
    
    const uniqueCountries = spanishNames.filter((country, index, self) => 
      index === self.findIndex(c => c.code === country.code)
    )
    
    setter(uniqueCountries)
  } catch(error) {
    return false
  }
}

export default GetCountries